import $ from "jquery";

export interface RollingNumberOptions {
    duration?: number;
}

export type RollingNumberEvent = "animation-started";

export class RollingNumberComponent {
    public static readonly SELECTOR = ".js-rolling-number";

    private $currentContext: JQuery = $();
    private $value: JQuery = $();
    private moduleOptions: Required<RollingNumberOptions> = {
        duration: 3000
    };

    private classMap = {
        value: ".js-rolling-number__value"
    };

    private subscriptions: Record<RollingNumberEvent, Array<() => void>> = {
        "animation-started": []
    };

    private _isAnimating = false;
    private _isAnimated = false;

    public get id(): string | number | undefined {
        return this.$currentContext.data("id") as string | number | undefined;
    }

    public get context(): JQuery {
        return this.$currentContext;
    }

    public get isAnimating(): boolean {
        return this._isAnimating;
    }

    public get isAnimated(): boolean {
        return this._isAnimated;
    }

    public init(context: JQuery, options?: RollingNumberOptions): void {
        this.$currentContext = context;
        $.extend(this.moduleOptions, options);
        this.$value = $(this.classMap.value, this.$currentContext);
    }

    public on(event: RollingNumberEvent, handler: () => void): void {
        if (this.subscriptions[event]) {
            this.subscriptions[event].push(handler);
        }
    }

    public animate(): void {
        if (this._isAnimating || this._isAnimated) {
            return;
        }

        const targetValue = parseFloat(this.$value.data("targetValue") as string) || 0;
        const duration = (this.$value.data("duration") as number) || this.moduleOptions.duration;

        this._isAnimating = true;
        this.invokeHandlers("animation-started");

        $({ counter: 0 }).animate({
            counter: targetValue
        }, {
            duration,
            easing: "swing",
            step: (currentNumber) => {
                this.$value.text(this.formatNumber(currentNumber));
            },
            complete: () => {
                this._isAnimating = false;
                this._isAnimated = true;
            }
        });
    }

    private formatNumber(num: number): string {
        return num.toFixed(0).replace(/\d(?=(\d{3})+$)/g, "$&,");
    }

    private invokeHandlers(event: RollingNumberEvent): void {
        const handlers = this.subscriptions[event];
        if (handlers) {
            handlers.forEach(handler => handler());
        }
    }
}
